export default "__VITE_ASSET__A5_Kshlo__"